module.exports = __webpack_public_path__ + "images/help/bg-roadmap-f3ba7f89702d30ed3dea8c86094f2ccd.png";